import { Component, Inject, OnInit } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { CommandeSettingsArticles } from '../shared/commande-param-settings'

@Component({
  selector: 'app-commande-confirm-modal',
  templateUrl: './commande-param-confirm-modal.component.html',
  styleUrls: [
    './commande-param-confirm-modal.component.scss'
  ]
})
export class CommandeParamConfirmModalComponent implements OnInit {

  article: CommandeSettingsArticles[]
  texteQuestion = ""
  texteSuppression = ""
  clientString = ""

  constructor(
    public dialogRef: MatDialogRef<CommandeParamConfirmModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  ngOnInit(): void {
    this.clientString = this.data.client.site.numero + " : " + this.data.client.code_client + "/" + this.data.client.code_service + " - " + this.data.client.raison_sociale
    if (this.data.params.comptageLingerieChanged) {
      if (!this.data.client.is_comptage_lingerie) {
        this.texteQuestion = "ajouter"
      } else {
        this.texteQuestion = "enlever"
      }
      this.texteQuestion += " la gestion par lingerie"
      this.texteSuppression = "à l'état 'A saisir'"
    } else if (this.data.params.comptageParJourChanged) {
      this.texteQuestion = "passer au comptage par"
      if (!this.data.client.is_comptage_jour) {
        this.texteQuestion += " jour"
      } else {
        this.texteQuestion += " coefficient"
      }
      this.texteSuppression = "aux états 'A saisir' et 'En attente'"
    }
  }

  closeDialog() {
    this.dialogRef.close(false)
  }

  confirm() {
    this.dialogRef.close(true)
  }
}
